import React, { FC } from "react";
import styles from "./center.module.scss";

const Center: FC = ({ children }) => (
	<div className={styles.center}>{children}</div>
);

export default Center;
